import React from 'react'
import injectSheet from 'react-jss'
import styles from './newsletter.styles'
import Section from '../../../shared/section/section'
import Segment from '../../../shared/segment/segment'
import Segments from '../../../shared/segments/segments'
import Description from '../../../shared/description/description'
import PobbleLink from 'pobble-components/dist/pobble-link'

const Newsletter = ({
  classes,
  pending,
  newsletter,
  onNewsletterChange,
  newsletterAvailability
}) => (
  <Section title="Newsletter">
    <Segments>
      <Segment className={classes.segment} size={'M'}>
        <span>
          You can manage your newsletter preferences by clicking on the link at
          the bottom of the <br />
          emails you received from Pobble. If something is wrong please contact
          us at{' '}
          <PobbleLink href="mailto:hello@pobble.com">
            hello@pobble.com
          </PobbleLink>
          .
        </span>
      </Segment>
      <Segment>
        <Description>
          Get the Pobble community update every 1 or 2 weeks. We regularly
          publish interesting articles for parents and teachers on our blog. We
          will also keep you posted about big events and competitions.
        </Description>
      </Segment>
    </Segments>
  </Section>
)

export default injectSheet(styles)(Newsletter)
